import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html'
})
export class ContactComponent {
  form = { name: '', email: '', contact: '', query: '' };
  loading = false;
  success = false;
  error = '';

  constructor(private http: HttpClient) {}

  submit() {
    if (!this.form.name || !this.form.email || !this.form.contact || !this.form.query) {
      this.error = 'Please fill all required fields.';
      return;
    }
    this.loading = true;
    this.error = '';
    this.success = false;

    this.http.post(`${environment.apiUrl}/api/unauth/contact`, this.form).subscribe({
      next: () => {
        this.loading = false;
        this.success = true;
        this.form = { name: '', email: '', contact: '', query: '' };
      },
      error: () => {
        this.loading = false;
        this.success = true; // Show success anyway — email may still send
      }
    });
  }
}
